import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

export default function SectionLayoutWrapper(props: any) {
  const router = useRouter();
  const [leftMarginValue, setLeftMarginValue] = useState("0px");

  useEffect(() => {
    if (router.pathname === "/") {
      setLeftMarginValue(
        window.getComputedStyle(document.getElementById("statComponent")!, null)
          .marginLeft
      );
    }
  }, []);

  useEffect(() => {
    function handleResize() {
      if (router.pathname === "/") {
        setLeftMarginValue(
          window.getComputedStyle(
            document.getElementById("statComponent")!,
            null
          ).marginLeft
        );
      }
    }

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const firstChildClasses =
    router.pathname === "/"
      ? "w-full lg:basis-4/6 sm:h-screen flex flex-col justify-between py-12 px-4 sm:py-16 sm:px-6 lg:px-0 lg:py-0"
      : "w-full lg:basis-4/6 sm:h-screen flex flex-col justify-between lg:px-0 lg:py-0";

  return (
    <div
      className="flex flex-row sm:min-h-screen"
      style={
        router.pathname === "/"
          ? {
              marginLeft: leftMarginValue,
            }
          : {}
      }
    >
      <div className={firstChildClasses}>{props.firstChild}</div>
      <div className="basis-3/6 bg-black relative sm:h-screen overflow-hidden hidden lg:block">
        {props.secondChild}
      </div>
    </div>
  );
}
